 const noTranslation = {
  header: {
    day: 'Dag',
    week: 'Uke',
    month: 'Mnd',
    administrator: 'Administrator',
    available: 'Tilgjengelig',
    logout: 'Logg ut',
    changeBloodbank: 'Endre blodbank',
    changePassword: 'Endre passord',
    changePhone: 'Endre telefonnummer',

    tooltip: {
      configuration: 'Innstillinger',
      week: 'Uke',
      messages: "Meldinger",
      donors: 'Givere',
      reports: 'Rapporter'
    }
  },

  auth: {
    username: 'Brukernavn',
    enterEmailOrUsername: 'Skriv inn e-postadresse eller brukernavn',
    password: 'Passord',
    enterPassword: 'Skriv inn passord',
    forgotPassword: 'Glemt passord',
    login: 'Logg inn',
    enterCorrectUsername: 'Brukernavn er feil',
    enterCorrectPassword: 'Passordet er feil',
    enterEmailToRecover: 'Vennligst oppgi e-post addresse for å gjenopprette ditt passord',
    enterEmail: 'Oppgi e-post',
    email: 'E-post',
    emailNotExist: 'E-post adressen eksisterer ikke',
    recoverPassword: 'Gjenopprett passord',
    createNewPassword: 'Lag nytt passord',
    changeBloodbank: 'Velg andre blodbank',
    changePassword: 'Endre gjeldene passord',
    currentPassword: 'Gjeldende passord',
    enterCurrentPassword: 'Oppgi gjeldende passord',
    newPassword: 'Nytt passord',
    enterNewPassword: 'Oppgi nytt passord',
    incorrectPassword: 'Passordet er feil',
    invalidPasswordComplex: 'Må inneholde minst {{minLength}} tegn, inkludert {{requirements}}.',
    invalidPasswordSimple: 'Må inneholde minst {{minLength}} tegn.',
    passwordRequirements: {
      lowercase: 'små bokstaver',
      uppercase: 'store bokstaver',
      digit: 'et tall',
      special: 'et spesialtegn'
    },
    identicalPassword: 'Passord er like',
    confirm: 'Bekreft',
    code: 'Kode',
    enterCodeToProceed: 'Vennlgst oppgi koden som har blitt sendt til ditt telefonnummer.',
    enterCode: 'Oppgi kode',
    enterYourCode: 'Oppgi kode',
    invalidCode: 'Ugyldig kode',
    signInRejected: 'Innloggingen ble avvist. Prøv på nytt – kontakt support hvis problemet vedvarer.',
    codeWasResent: 'Ny kode er sendt til ditt telefonnummeret',
    phoneWasChanged: 'Telefonnummer endret',
    changePhoneNumber: 'Endre telefonnummer',
    newPhoneNumber: 'Nytt telefonnummer',
    enterPhoneNumber: 'Oppgi telefonnummer',
    invalidPhoneNumber: 'Ugyldig telefonnummer',
    resentCode: 'Har du ikke motttatt kode, vennligst klikk',
    here: 'her',
    enterYourCountry: 'Oppgi land',
    loginError: 'Feil brukernavn eller passord',
    loginUnavailable: 'Tjenesten er ikke tilgjengelig akkurat nå. Prøv igjen om litt.',
    firewallErrorTitle: 'Får ikke kontakt med eksterne tjenester',
    firewallError: 'Be IT-avdelingen kontrollere at følgende adresser ikke er blokkert av brannmur:',
    expiredPasswordResetLinkModal: {
      header: 'Tilbakestill passordet ditt på nytt',
      body: 'Lenken for tilbakestilling er utløpt eller har allerede blitt brukt',
    }
  },

  configuration: {
    overwriteModal:{
      header:'Overskriv timeavtale',
      body:'Opprinnelig timeavtale vil overskrives. Er du sikker på at du vil overskrive timeavtale med nye verdier?',
      body2: 'Donorstatus vil bli satt til Avklares. Vil du fortsette?',
      applyButton: 'Ja'
    },
    resourceDeleteModal: {
      header: 'Fjern ressurs',
      body1: 'Du kan ikke slette en ressurs med den eksisterende tidsluken på den!',
      body2: 'Er du sikker på at du vil slette denne ressursen?',
      delete: 'Fjern',
    },
    resourceEditModal: {
      header: 'Endre ressurs',
      body: 'Velg nytt navn for denne ressursen (hvis tom vil indeksen bli brukt)',
      input: 'Ressursnavn',
      edit: 'Endre',
    },
    deleteResource: 'Fjern ressurs',
    editResource: 'Endre ressurs',
    template: 'Velg mal',
    Plain: 'Enkel',
    newResource: 'Ny ressurs',
    resourceLimit: 'Maks antall ressurser er nådd',
    editTimeslot: 'Endre tidsbolker',
    deleteAppointment: 'Fjern avtale',
    bookAppointment: 'Book time',
    cancelBooking: 'Avbestill booking',
    deleteTimeslot: 'Fjern tidsbolk',
    downtime: 'Nedetid',
    settings: {
      header: 'Innstillinger for tidsbolker',
      appointmentDuration: 'Avtalevarighet',
      allBloodTypes: 'Alle blodtyper',
      selectBloodType: 'Vennligst velg blodtype',
      from: 'Fra',
      to: 'Til',
      startDate: 'Start dato',
      startTime: 'Start tid',
      endTime: 'Slutt tid',
      shouldBeBeforeEnd: 'Bør forekomme før sluttidspunkt',
      shouldBeAfterStart: 'Bør forekomme etter starttidspunkt',
      shouldBeGraterThanDuration: 'Bør ikke være mindre enn avtalt varighet',
      shouldBeLessThanTheEndTime: 'Start tiden må være før slutt tid',
      shouldNotBeLessThanDuration: 'Tidslengden må være lengre enn avtalevarighet',
      allDay: 'Hele dagen',
      recurring: 'Gjentakende',
      exceptions: 'Unntak',
      add: 'Legg til',
      discard: 'Forkast',
      edit: 'Endre',
      remove: 'Fjern',
      change: 'Endre',
      titer: {
        allVariants: 'Alle varianter',
        low: 'Lav',
        high: 'Høy',
        unknown: 'Ukjent',
        title: 'Titer (anti -A og -B)',
      },
      discardModal: {
        header: 'Forkast endringer?',
        body: 'Alle endringer vil bli forkastet. Er du sikker på at du vil fortsette?',
      },
      conflictModal: {
        header: 'Konflikt med andre tidsbolker',
        body: 'Den nye tidsbolken strider med eksisterende tidsbolk på ressurs {{resourceIndex}}. Du kan endre innstillingene eller opprette tidsbolken i en annen ressurs.',
      },
      noResourcesModal: {
        header: 'Ingen tilgjengelige ressurser',
        body: 'Ingen tilgjengelige ressurser. Vennligst endre tidsbolk instillingene.',
      },
      cancelAppointmentsModal: {
        header: 'Kanseller avtaler',
        body: 'Vennligst canceller alle kommende avtaler før endringene kan gjennomføres.',
      },
      deleteTimeslotModal: {
        header: 'Fjern tidsbolk',
        body1: 'Tidsbolken har kommende reservasjoner. Reservasjonene beholdes som enkeltstående timer, resten av tidsbolken fjernes. Er du sikker på at du vil fjerne tidsbolken?',
        body2: 'Er du sikker på at du vil fjerne tidsbolken?',
      },
      deleteAppointmentModal: {
        header: 'Fjern avtale',
        body1: 'Er du sikker på at du vil slette denne?',
        body2: 'Du kan ikke slette den siste avtalen!',
      },
      bookAppointmentModal: {
        header: 'Book time',
        id: 'Fødselsnummer',
        searchPlaceholder: 'Skriv inn fødselsnummer',
        noMatch: 'Ingen treff for',
        selectAppointmentTime: 'Velg avtaletid',
        appointmentType: 'Velg avtaletype',
        appointmentTypeSelect: 'Velg en avtaletype',
        nextAppointment: 'Denne giveren har allerede en reservert time',
        statusNotMatch: 'Giver er ikke kvalifisert til å reservere denne timen',
        titerNotMatch: 'Brukertiter samsvarer ikke med avtalen',
        donorTypeNotMatch: 'Donortype samsvarer ikke med avtale',
        inQuarantine: 'Bruker i karantene',
        overlapReserved: 'Det valgte tidsrommet overlapper med en eksisterende booking.',
        overlapTitle: 'Kan ikke booke avtale',
        forceBookTitle: 'Bookingsjekker feilet — fortsette?',
        forceBookBody: 'Vi fant følgende problemer; bekreft om du vil fortsette.',
        forceBook: 'Tving Booking',
        forceBookNotAllowed: 'Denne bookingen kan ikke tvinges gjennom fordi en eller flere sjekker ikke kan overstyres.',
        forceBookCheckEarliestDate: 'Tidligste tillatte dato er {{date}}.',
        forceBookCheckQuarantine: 'Giveren er i karantene til {{date}}.',
        forceBookCheckAboMismatch: 'ABO samsvarer ikke med kravene for avtalen.',
        forceBookCheckRhdMismatch: 'Rhesus (RhD) samsvarer ikke med kravene for avtalen.',
        forceBookCheckAboRhdMismatch: 'ABO og Rhesus (RhD) samsvarer ikke med kravene for avtalen.',
        bloodTypeMismatchError: 'Giveren oppfyller ikke avtalens krav til blodtype.',
        forceBookCheckNotEligible: 'Giveren er ikke kvalifisert for denne avtaletypen.',
        forceBookCheckMissingEligibility: 'Giverens kvalifiseringsdata mangler for denne avtaletypen.',
        forceBookCheckTimeslotRange: 'Avtaledatoen er utenfor tidsluken.',
        forceBookCheckAppointmentTypeMismatch: 'Valgt avtaletype «{{selectedType}}» samsvarer ikke med tidsbolkens type «{{originalType}}». Opprinnelig avtale vil bli overskrevet.',
        forceBookCheckExistingAppointment: 'Giveren har allerede en booking den {{date}} kl. {{time}}.',
        forceBookCheckUnknown: 'Ukjent sjekk feilet: {{check}}.',
        forceBookOverridable: 'Kan overstyres',
        forceBookNotOverridable: 'Kan ikke overstyres',
        bookingEligibilityMissing: 'Bookingens kvalifikasjonsdata mangler. Denne giveren kan ikke bookes for denne avtaletypen.',
        eligibilityCheckFailed: 'Kunne ikke hente hvilke avtaletyper giveren kan bookes til. Prøv igjen — booking er sperret inntil sjekken lykkes.',
        earliestDateWarning: 'Tidligste bookbare dato er {{date}}.',
        cancel: 'Avbryt',
      },
      cancelBookingModal: {
        header: 'Avbestill booking?',
        body: 'Den reserverte bookingen vil bli forkastet. Er du sikker på at du vil fortsette?',
        selectAppointmentTime: 'Velg avtaletid',
      },
      counter: {
        pending: 'Venter',
        reserved: 'Reservert',
        archived: 'Arkivert'
      },
      redDayWarning: 'Rød dag',
    },
    recurrence: {
      header: 'Innstillinger for gjentakelse',
      daily: 'Daglig',
      occur: 'Oppstår',
      everyDay: 'Hver ukedag',
      every: 'Hver',
      days: 'dager',
      weekly: 'Ukentlig',
      weeks: 'uke(r)',
      on: 'På',
      monthly: 'Månedlig',
      months: 'måned',
      onDay: 'På dagen',
      onThe: 'På',
      First: 'Første',
      Second: 'Andre',
      Third: 'Tredje',
      Fourth: 'Fjerde',
      Last: 'Siste',
      ends: 'Ender',
      by: 'Ender',
      after: 'Etter',
      occurrences: 'forekomster',
      noEndDate: 'Ingen slutt dato',
    },
    exceptions: {
      header: 'Innstillinger for unntak',
      excludeDate: 'Ekskluder dato',
      addException: 'Legg til unntak',
      dates: 'Datoer',
      clearAll: 'Fjern alle',
      excludeHours: 'Ekskluder tid',
      from: 'Fra',
      to: 'Til',
      onThe: 'På',
      nonworkingHours: 'Ekskludert',
      datesAndHours: 'Tid og dato',
      excludeHoursOnDate: 'Ekskluder tid på dato',
    },
  },

  dashboard: {
    tasks: 'OPPGAVER',
    findDonor: 'Søk giver',
    search: 'Søk',
    available: 'Ledig',
    reserved: 'Reservert',
    didAttend: 'Møtt',
    didNotAttend: 'Ikke møtt',
    signups: 'Innmeldinger',
    attendance: 'Fremmøte',
  },

  donorDetails: {
    header: 'Giverdetaljer',
    idNumber: 'Fødselsnummer',
    lastDraw: 'Siste avtale',
    noLastDraw: 'Ingen tidligere avtale',
    quarantine: 'Karantene',
    quarantineExpires: 'Karantene utløper',
    noQuarantineDate: 'Ingen karantene',
    description: 'Beskrivelse',
    nextAppointment: 'Neste avtale',
    donorContacts: 'Kontaktdetaljer',
    address: 'Adresse',
    postalCode: 'Postnummer',
    city: 'Sted',
    email: 'E-post',
    phone: 'Telefonnummer',
    becs: 'Opprettet i Blodbanksystemet',
    appuser: 'APP-bruker',
    sms: 'SMS',
    donationSite : 'Valgt sted',
    // CMT-57 «Bytt tappested (innen HF)»: the confirmation before a donor is
    // moved to another donation site, and the one rejection explained here
    moveDonor: {
      title: 'Flytt giver til {{site}}?',
      body: 'Giveren forsvinner fra giverlisten til {{from}} og vises under {{to}}.',
      confirm: 'Flytt',
      activeBooking: 'Giveren har en aktiv time. Avbestill timen før giveren flyttes.',
      // CMT-87: sysadmin has not switched «Bytt tappested» on for the HF
      featureDisabled: 'Bytte av tappested er ikke aktivert for dette helseforetaket.',
    },
  },

  showUp: {
    header: 'Møtt til time',
    yes: 'Ja',
    no: 'Nei',
  },

  common: {
    selectValue: 'Velg',
    quarantineDue: 'Karantene utløper',
    nextAppointment:'Neste avtale',
    confirm: 'Bekreft',
    book: 'Book',
    cancel: 'Avbryt',
    close: 'Lukk',
    clear: 'Nullstill',
    apply: 'Bruk',
    save: 'Lagre',
    delete: 'Slett',
    proceed: 'Fortsett',
    ok: 'Ok',
    all: 'Alle',
    cancelBooking: 'Avbestill',
    bloodType: 'Blodtype',
    donorType: {
      header: 'Givertype',
      full_blood: 'Fullblod',
      apheresis: 'Aferese',
    },
    titer: {
      low: 'Lav',
      high: 'Høy',
      unknown: 'Ukjent',
      title: 'Titer (anti -A og -B)',
    },
    appointmentType: {
      header: 'Avtaletype',
      'New registration': 'Nyregistrering',
      'First time draw': 'Førstegangs tapping',
      'N\'th time draw': 'Vanlig tapping',
      'Erythrocytapheresis': 'Erytrocytter',
      'Plateletpheresis': 'Trombocytter',
      'Plasmapheresis': 'Plasma',
      'Consultation': 'Konsultasjon',
    },
    appUserStatus: {
      header: 'APP-bruker',
      yes: 'Ja',
      no: 'Nei',
    },
    eligibleFor: 'Egnet for',
    selfService: 'Selvbetjening',
    appointmentStatus: {
      header: 'Avtale',
      yes: 'Ja',
      no: 'Nei',
    },
    smsStatus: {
      header: 'SMS',
      true: 'Ja',
      false: 'Nei',
    },
    donorStatus: {
      header: 'Giverstatus',
      new: 'Ny',
      approved: 'Godkjent',
      established: 'Etablert',
      pending: 'Avklares',
    },
    month: {
      January: 'Januar',
      February: 'Februar',
      March: 'Mars',
      April: 'April',
      May: 'Mai',
      June: 'Juni',
      July: 'Juli',
      August: 'August',
      September: 'September',
      October: 'Oktober',
      November: 'November',
      December: 'Desember',
      Jan: 'Jan',
      Feb: 'Febr',
      Mar: 'Mars',
      Apr: 'April',
      Jun: 'Juni',
      Jul: 'Juli',
      Aug: 'Aug',
      Sep: 'Sept',
      Oct: 'Okt',
      Nov: 'Nov',
      Dec: 'Des',
    },
    day: {
      Sunday: 'Søndag',
      Monday: 'Mandag',
      Tuesday: 'Tirsdag',
      Wednesday: 'Onsdag',
      Thursday: 'Torsdag',
      Friday: 'Fredag',
      Saturday: 'Lørdag',
      Sun: 'Søn',
      Mon: 'Man',
      Tue: 'Tirs',
      Wed: 'Ons',
      Thu: 'Tor',
      Fri: 'Fre',
      Sat: 'Lørd',
      Su: 'Sø',
      Mo: 'Ma',
      Tu: 'Ti',
      We: 'On',
      Th: 'To',
      Fr: 'Fr',
      Sa: 'Lø',
    }
  },

  pagination: {
    previous: 'Forrige',
    next: 'Neste',
    rows_amount: 'Antall rader',
    of: 'av',
    all: 'alle',
  },

  table: {
    no_data: 'Det er ingen data',
    no_match: 'Det er ingen match til',
    try_another: 'Prøv et nytt søk',
    name: 'Navn',
    ID_number: 'Fødselsnummer',
    last_draw: 'Siste avtale',
    blood_type: 'Blodtype',
    titer: 'Titer',
    donor_status: 'Giverstatus',
    donor_type: 'Givertype',
    quarantine_due_date: 'Karantene utløper',
    app_user: 'APP-bruker',
    sms: 'SMS',
    next_appointment: 'Neste avtale',

    id: 'ID',
    date: 'Dato / KI.',
    title: 'Tittel',
    message: 'Melding',
    signature: 'Signatur',
    candidate: 'Kandidat',

    message_id: 'Melding ID',
    receiver_id: 'Mottaker ID',
    category: 'Category',

    msg_type: 'Type',
    msg_source: 'Kilde',
  },

  msgs: {
    index: 'Index',
    id: 'ID',
    date: 'Dato / KI.',
    title: 'Tittel',
    message: 'Melding',
    authorized_user: 'Pålogget bruker',
    messages_editor: 'Meldings editor',
    send: 'Send',
    candidates_amount: 'Antall kandidater',
    search: 'Søk',
    admin: 'Admin',
    system_sent: 'Auto',
    system_scheduled: 'Planlagt',
    filterMatches: '{{count}} givere matcher',
    filter_settings: 'Innstillinger for filter',
    filter: 'Filter',
    message_id: 'Melding ID',
    receiver_id: 'Mottaker ID',
    queued: 'Meldingen er lagt i kø',
    status: {
      queued: 'I kø',
      processing: 'Sendes',
      failed: 'Feilet',
    },

    // PNR search: every message one donor received, all types
    donor: {
      truncated: 'Viser bare de {{count}} nyeste meldingene.',
      error: {
        donor_not_in_bloodbank: 'Giveren tilhører ikke denne blodbanken',
        donor_not_found: 'Fant ingen giver',
        request_failed: 'Kunne ikke hente meldingene til giveren',
      },
      type: {
        donor_ready: 'Klar for tapping',
        donor_quarantine: 'Karantene utløper',
        donor_cancel: 'Avbestilt time',
        donor_cancelled: 'Avbestilt time',
        donor_upcoming_1w: 'Påminnelse (1 uke)',
        donor_upcoming_1d: 'Påminnelse (1 dag)',
        donor_upcomed: 'Bekreftelse på time',
        donor_upcoming: 'Påminnelse',
        mismatch_cancelled: 'Kansellert (endret giverprofil)',
        email_reminder: 'Påminnelse om e-post',
        // legacy documents without a type: inferred from the text
        registration: 'Registrering',
        // nothing matched
        unknown: 'Melding',
      },
    },

    tooltip: {
      bloodbank: 'Blodbank',
      blood_type: 'Blodtype',
      titer: 'Titer',
      donor_status: 'Giverstatus',
      app_user: 'APP-bruker',
      sms: 'SMS',
    }
  },

  reports: {
    title: 'Rapporter',
    stage: {
      alpha: 'Alfa',
      beta: 'Beta',
    },
    alphaNote: 'Rapporter er en alfa-funksjon. Innholdet kan endre seg, og tallene kan avvike fra blodbankens eget system.',
    unavailable: {
      title: 'Ikke tilgjengelig',
      message: 'Rapporter er ikke aktivert for din bruker.',
    },
    noAccess: 'Du har ikke tilgang til rapporter for denne blodbanken.',
    noBloodbank: 'Velg en blodbank for å se rapporter.',
    period: {
      label: 'Periode',
      from: 'Fra',
      to: 'Til',
      preset: 'Siste {{count}} mnd',
      invalid: 'Velg en periode på 1–24 måneder der «fra» ikke er etter «til».',
    },
    export: 'Last ned CSV',
    loading: 'Henter tall …',
    empty: 'Ingen data for perioden',
    emptyHint: 'Prøv en lengre periode, eller velg en annen blodbank.',
    error: {
      title: 'Kunne ikke hente rapporten',
      retry: 'Prøv igjen',
    },
    inProgress: 'pågår',
    inProgressNote: 'Måneder merket «pågår» er ikke avsluttet, og tallene kan fortsatt endre seg.',
    updatedAt: 'Oppdatert {{date}}',
    footer: 'Tallene gjelder bookinger og givere registrert i Blodgiver. Tappedata (Hb, avvisninger, volum) finnes i blodbankens eget system.',
    sections: {
      attendance: 'Oppmøte',
      cancellations: 'Avbestillinger',
      capacity: 'Kapasitet',
      channel: 'Bookingkanal',
      donors: 'Giverbase',
      messages: 'Meldinger',
      matrix: 'Avtaletype × blodtype',
      table: 'Månedstabell',
    },
    summary: {
      title: 'Oversikt',
    },
    groups: {
      bookings: 'Bookinger',
      donors: 'Givere og meldinger',
      details: 'Detaljer',
    },
    chart: {
      perMonth: 'Per måned',
      by: 'Fordelt etter {{dimension}}',
    },
    table: {
      total: 'Totalt',
    },
    kpi: {
      booked: 'Booket',
      attended: 'Møtt',
      noShow: 'Ikke møtt',
      noShowRate: 'No-show-andel',
      cancelled: 'Avbestilt',
      slots: 'Slots',
      capacityBooked: 'Bookede slots',
      free: 'Ledige slots',
      utilisation: 'Utnyttelse',
      donorsTotal: 'Givere',
      inQuarantine: 'I karantene',
      withApp: 'Med app',
      newRegistrations: 'Nye registreringer',
      lapsed12m: 'Ikke møtt på 12+ mnd',
      messagesCount: 'Utsendinger',
      audienceSize: 'Mottakere',
      smsCount: 'SMS',
      month: 'Måned',
    },
    hints: {
      noShowRate: 'Ikke møtt delt på møtt + ikke møtt',
      donorsAsOf: 'Giverbasen slik den var ved siste beregning ({{month}}). Nye registreringer er summert for perioden.',
      bookedCancelled: 'Booket og avbestilt telles i måneden handlingen ble gjort; møtt og ikke møtt i måneden avtalen var.',
      rateWhenClosed: 'Vises når måneden er avsluttet',
    },
    notes: {
      cancellations: 'Avbestillinger per måned, fordelt på hvem som avbestilte og hvor lenge før avtalen det skjedde.',
      capacity: 'Hvor mange av de tilgjengelige timene (slots) som ble booket, per måned og per ukedag og klokkeslett.',
      channel: 'Hvor bookingene kommer fra: giverne selv i appen eller ansatte i blodbanken.',
      messages: 'Meldinger sendt til givere per måned: antall utsendinger, mottakere og SMS.',
      table: 'Alle månedstallene samlet i én tabell, med sum for perioden nederst. Kan lastes ned som CSV.',
    },
    breakdown: {
      label: 'Fordel etter',
      none: 'Ingen',
      appointmentType: 'Avtaletype',
      bloodType: 'Blodtype',
      donorStatus: 'Giverstatus',
      titer: 'Titer',
      channel: 'Kanal',
      perMonth: 'Vis per måned for',
      all: 'Alle',
      empty: 'Ingen bookinger å fordele i perioden',
    },
    channel: {
      donor: 'Giver (app)',
      staff: 'Ansatt',
      system: 'System',
      shareTitle: 'Andel bookinger per kanal',
    },
    leadTime: {
      title: 'Tid fra avbestilling til avtalen',
      lt24h: 'Under 24 t',
      '24to72h': '24–72 t',
      gt72h: 'Over 72 t',
    },
    donorStatus: {
      new_registration: 'Nyregistrering',
      new: 'Ny',
      approved: 'Godkjent',
      established: 'Etablert',
      pending: 'Venter',
      ukjent: 'Ukjent',
    },
    titer: {
      high: 'Høy',
      low: 'Lav',
      ukjent: 'Ukjent',
    },
    unknown: 'Ukjent',
    weekdays: {
      1: 'Man',
      2: 'Tir',
      3: 'Ons',
      4: 'Tor',
      5: 'Fre',
      6: 'Lør',
      7: 'Søn',
    },
    heatmap: {
      title: 'Utnyttelse per ukedag og time',
      hour: 'Kl.',
      cell: '{{booked}} av {{slots}} slots booket',
      empty: 'Ingen kapasitetsdata for perioden',
      legendLow: 'Lav',
      legendHigh: 'Høy',
    },
    donors: {
      byStatus: 'Etter status',
      byBloodType: 'Etter blodtype',
    },
    matrix: {
      booked: 'booket',
      attended: 'møtt',
      cellFormat: '{{booked}} / {{attended}}',
      legend: 'Booket / møtt, summert for perioden',
      empty: 'Ingen bookinger for perioden',
      total: 'Totalt',
    },
  },

  recurrenceSummary: {
    everyDay: 'Hver dag',
    everyNDays: 'Hver {{n}}. dag',
    everyWeek: 'Hver uke',
    everyNWeeks: 'Hver {{n}}. uke',
    everyMonth: 'Hver måned',
    everyNMonths: 'Hver {{n}}. måned',
    onWeekdays: 'på {{days}}',
    onMonthDay: 'den {{day}}.',
    onMonthWeekday: 'den {{ordinal}} {{weekday}}',
    until: 'frem til og med {{date}}',
    times: '{{n}} ganger',
    weekday: {
      Sunday: 'søndag',
      Monday: 'mandag',
      Tuesday: 'tirsdag',
      Wednesday: 'onsdag',
      Thursday: 'torsdag',
      Friday: 'fredag',
      Saturday: 'lørdag',
    },
    weekdayDefinite: {
      Sunday: 'søndagen',
      Monday: 'mandagen',
      Tuesday: 'tirsdagen',
      Wednesday: 'onsdagen',
      Thursday: 'torsdagen',
      Friday: 'fredagen',
      Saturday: 'lørdagen',
    },
    ordinal: {
      First: 'første',
      Second: 'andre',
      Third: 'tredje',
      Fourth: 'fjerde',
      Last: 'siste',
    },
  },

  exceptionSummary: {
    hoursOnWeekdays: 'Fra {{from}} til {{to}} på {{days}}',
    hoursOnDate: 'Fra {{from}} til {{to}} {{date}}',
    weekday: {
      Sun: 'søn',
      Mon: 'man',
      Tue: 'tir',
      Wed: 'ons',
      Thu: 'tor',
      Fri: 'fre',
      Sat: 'lør',
    },
  },

  errorBoundary: {
    title: 'Noe gikk galt',
    message: 'Det oppstod et problem ved innlasting av siden. Vennligst sjekk tilkoblingen din og prøv igjen.',
    retry: 'Prøv igjen',
  },
}

export default noTranslation;
